import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import { Card} from 'react-bootstrap';
import './CardTemplate.css';

const CardTemplate = (props) => {
    return(
        <Card className='Fields'>
        <Card.Body>
        {props.icon}
          <Card.Title>{props.title}</Card.Title>
          <Card.Text>
            {props.text}
          </Card.Text>
        </Card.Body>
        </Card>
        )
    }
    
    export default CardTemplate;